// extracted by mini-css-extract-plugin
export default {"project":"ArchivedProject_project__MZ-5v","title":"ArchivedProject_title__rqJJF","description":"ArchivedProject_description__ea5-i","icons":"ArchivedProject_icons__NkVSv"};